




























































































































import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { AuthParams } from '@/models/userdata/authparams';
import VueRecaptcha from 'vue-recaptcha';
import { Frictionless } from '../models/referrals/frictionless';
import { ReferralPayload } from '../models/referrals/referralPayload';
import { Referral } from '../models/referrals/referral';
import router from '../router';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'AppShare',
  components: {
    VueRecaptcha,
  },
})
export default class AppShare extends Vue {
  private frictionLess: Frictionless = new Frictionless();
  private isNotARobot: boolean = false;
  private fullName: string = '';
  private email: string = ''; // email or phone
  private emailId: string = '';
  private phone: string = '';
  private errorString: string = '';
  $wlToastr: any;

  mounted() {
    Vue.cookies.remove('referringComponenet');
    Vue.cookies.remove('referralSuccess');
    Vue.cookies.remove('frictionLess');
    if (this.$route.query.fullName) {
      this.fullName = this.$route.query.fullName.toString();
    }
    if (this.$route.query.email) {
      this.email = this.$route.query.email.toString();
    }
  }

  googleLogin() {
    this.setOAuthProvider('google');
    this.setReferringComponent('AppShare');
    return vxm.users.loginWithGoogle();
  }

  get CaptchaClientSiteKey() {
    return vxm.configs.getGlobalConfigValue('RECAPTCHA_CLIENT_SITE_KEY');
  }

  facebookLogin() {
    this.setOAuthProvider('facebook');
    this.setReferringComponent('AppShare');
    return vxm.users.loginWithFacebook();
  }

  setOAuthProvider(provider: string) {
    this.$cookies.set('OAuthProvider', provider, 300);
  }

  setReferringComponent(component: string) {
    this.$cookies.set('referringComponent', component);
  }

  intiateFrictionlessReferral() {
    vxm.referrals.postFrictionlessReferral(this.frictionLess);
  }

  onCaptchaVerified(recaptchaToken) {
    vxm.referrals.getRecaptchaResponse(recaptchaToken);
  }

  goToInvite() {
    const vm = this;
    if (!vm.validateDataAppShareReferral()) {
      vm.$wlToastr('error', vm.$t(vm.errorString), 'Referral');
    } else {
      const referral = new Referral();
      referral.userFullName = this.fullName;
      referral.email = this.emailId;
      referral.phoneNbr = this.phone;
      referral.referralCode = vxm.referrals.globalRefCode;
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      referral.referralType = 'app';
      console.log(referral);

      const respPromise: any = vxm.referrals.checkQuickSignupUserexist(
        referral,
      );
      Promise.all([respPromise]).then((values) => {
        console.log(values[0].success);
        if (!values[0].success) {
          if (values[0].errorCode === '90') {
            vm.$wlToastr(
              'info',
              this.$t('jobshare.already.registered.text'),
              'Referral',
            );
          } else {
            vxm.referrals.jobShareReferral(referral);
          }
        } else {
          vxm.referrals.jobShareReferral(referral);
        }
      });
    }
  }
  validateDataAppShareReferral(): boolean {
    const vm = this;
    if (!vm.fullName) {
      this.errorString = 'jobshare.fullname.required';
      return false;
    }
    if (!vm.email) {
      this.errorString = 'jobshare.email.required';
      return false;
    }
    const emailorphone = vm.email;
    if (vm.isNumber(emailorphone)) {
      this.phone = this.email;
      if (vm.email.length !== 10) {
        this.errorString = 'jobshare.phone.valid';
        return false;
      }
    } else {
      this.emailId = this.email;
      if (
        vm.email.includes('@') === false ||
        vm.email.includes('.') === false
      ) {
        this.errorString = 'jobshare.enter.valid.email';
        return false;
      }
    }

    if (!vxm.referrals.RecaptchaResponse.success) {
      this.errorString = 'jobshare.enter.recaptcha.response';
      return false;
    }
    return true;
  }

  findJob() {
    router.push({ name: 'Findjobs' });
  }

  isNumber(value: string | number): boolean {
    return value != null && !isNaN(Number(value.toString()));
  }
}
